import React, { useEffect, useState } from 'react';
import { Fab, Zoom } from '@mui/material';
import { KeyboardArrowUp as KeyboardArrowUpIcon } from '@mui/icons-material';

const ScrollToTop = () => {
	const [visible, setVisible] = useState(false);
	const [chatOpen, setChatOpen] = useState(false);

	useEffect(() => {
		const onScroll = () => setVisible(window.scrollY > 320);
		window.addEventListener('scroll', onScroll, { passive: true });
		onScroll();
		return () => window.removeEventListener('scroll', onScroll);
	}, []);

	useEffect(() => {
		const handler = (e) => setChatOpen(e.detail);
		window.addEventListener('floatingChatToggle', handler);
		return () => window.removeEventListener('floatingChatToggle', handler);
	}, []);

	const handleClick = () => {
		window.scrollTo({ top: 0, behavior: 'smooth' });
	};

	return (
		<Zoom in={ visible && !chatOpen }>
			<Fab
				onClick={ handleClick }
				size="medium"
				aria-label="Lên đầu trang"
				sx={ {
					position: 'fixed',
					right: { xs: 16, md: 28 },
					bottom: { xs: 16, md: 28 },
					zIndex: 1300,
				bgcolor: '#D4AF37',
				color: '#000',
				boxShadow: '0 8px 24px rgba(212,175,55,0.35)',
				'&:hover': { bgcolor: 'rgba(212,175,55,0.85)' },
				} }
			>
				<KeyboardArrowUpIcon />
			</Fab>
		</Zoom>
	);
};

export default ScrollToTop;
